import * as React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import Theme from '../../styles/theme';

import './theme-reset.css';
import './fontawesome-icons.css';
import './fontspot-icons.css';
import './font.css';
import './gabarit.css';
import './scrollbar.css';
import './animation.css';

/**
 * Props Type for JRCThemeProviderProps
 * @member children : enclosed React component
 */
export interface JRCThemeProviderProps {
    layout?: boolean;
    children: React.ReactNode;
}

const Div = styled.div`
    display: flex;
    flex: 1;

    --font-family: ${(props) => props.theme.font.family};
    font-family: var(--font-family);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;

    /* Font variant */
    font-variant-ligatures: none;
    -webkit-font-variant-ligatures: none;
    /* Smoothing */
    text-rendering: optimizeLegibility;
    font-smooth: always;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: subpixel-antialiased;
`;

const DivReset = styled.div`
    display: flex;
    flex: 1;
`;

export const JRCThemeProvider = ({ layout = false, children }: JRCThemeProviderProps) => {
    return layout ? (
        <ThemeProvider theme={Theme.get()}>
            <Div>
                <DivReset className="react-reset">{children}</DivReset>
            </Div>
        </ThemeProvider>
    ) : (
        <div className="react-reset">
            <ThemeProvider theme={Theme.get()}>{children}</ThemeProvider>
        </div>
    );
};
